import Vue from 'vue'
import Router from 'vue-router'

// in development-env not use lazy-loading, because lazy-loading too many pages will cause webpack hot update too slow. so only in production use lazy-loading;
// detail: https://panjiachen.github.io/vue-element-admin-site/#/lazy-loading

Vue.use(Router)

/* Layout */
import Layout from '../views/admin/layout/Layout'

/**
* hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
* alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
*                                if not set alwaysShow, only more than one route under the children
*                                it will becomes nested mode, otherwise not show the root menu
* redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
* name:'router-name'             the name is used by <keep-alive> (must set!!!)
* meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
**/
export const constantRouterMap = [
  { path: '/login', component: () => import('@/views/login/index'), hidden: true },
  { path: '/404', component: () => import('@/views/404'), hidden: true },
  { path: '', component: () => import('@/views/home/index'), hidden: true },
  { path: '/legal', component: () => import('@/views/legal/legal'), hidden: true },
  { path: '/privacy', component: () => import('@/views/legal/privacy'), hidden: true },
  { path: '/cookie', component: () => import('@/views/legal/cookie'), hidden: true }
]

export default new Router({
  // mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap,
  mode: 'history'
})

export const unconfirmedRouterMap = [
  { path: '/dashboard', component: () => import('@/views/unconfirmed/index'), hidden: true },
  { path: '*', redirect: '/404', hidden: true }
]

export const asyncRouterMap = [
  {
    path: '/dashboard',
    component: Layout,
    redirect: 'dashboard',
    name: 'Dashboard',
    meta: { title: 'Dashboard' },
    children: [{
      path: '',
      component: () => import('@/views/admin/dashboard/index'),
      meta: { title: 'Dashboard', icon: 'el-icon-date' }
    },
    {
      path: 'instance',
      component: () => import('@/views/admin/dashboard/index'),
      name: 'New Instance',
      meta: { title: 'New Instance' },
      hidden: true
    }]
  },
  {
    path: '/users',
    component: Layout,
    redirect: 'users',
    name: 'Users',
    meta: { roles: 'generalmanager', title: 'Users' },
    children: [{
      path: '',
      component: () => import('@/views/admin/users/index'),
      meta: { title: 'Users', icon: 'el-icon' }
    }]
  },
  // {
  //   path: '/lockers',
  //   component: Layout,
  //   redirect: 'lockers',
  //   name: 'Lockers',
  //   meta: { roles: 'safemanager', title: 'Lockers' },
  //   children: [{
  //     path: '',
  //     component: () => import('@/views/admin/lockers/hux'),
  //     meta: { title: 'Lockers', icon: 'list' }
  //   }]
  // },
  // {
  //   path: '/lockers',
  //   component: Layout,
  //   redirect: 'lockers',
  //   name: 'Lockers',
  //   meta: { roles: 'generalmanager', title: 'Lockers' },
  //   children: [{
  //     path: '',
  //     component: () => import('@/views/admin/lockers/kylo'),
  //     meta: { title: 'Lockers', icon: 'list' }
  //   }]
  // },
  // {
  //   path: '/lockers',
  //   component: Layout,
  //   redirect: 'lockers',
  //   name: 'Lockers',
  //   meta: { roles: 'safemerchant', title: 'Lockers' },
  //   children: [{
  //     path: '',
  //     component: () => import('@/views/admin/lockers/trooper'),
  //     meta: { title: 'Lockers', icon: 'list' }
  //   }]
  // },
  {
    path: '/products',
    component: Layout,
    redirect: 'products',
    name: 'Products',
    meta: { roles: 'xferopaymentmanager', title: 'Products' },
    children: [{
      path: '',
      component: () => import('@/views/admin/product/index'),
      meta: { title: 'Products', icon: 'el-icon-shopping-cart-2' }
    }]
  },
  {
    path: '/orders',
    component: Layout,
    redirect: 'orders',
    name: 'Orders',
    meta: { roles: 'xferopaymentmanager', title: 'Orders' },
    children: [{
      path: '',
      component: () => import('@/views/admin/product/order'),
      meta: { title: 'Orders', icon: 'el-icon-date' }
    }]
  },
  // {
  //   path: '/history',
  //   component: Layout,
  //   redirect: 'history',
  //   name: 'History',
  //   children: [{
  //     path: '',
  //     component: () => import('@/views/pilih/history'),
  //     meta: { title: 'History', icon: 'list' }
  //   }]
  // },
  {
    path: '/profile',
    component: Layout,
    redirect: 'profile',
    name: 'Profile',
    meta: { title: 'Profile' },
    children: [{
      path: '',
      component: () => import('@/views/admin/profile/index'),
      meta: { title: 'Profile', icon: 'el-icon-user' }
    }]
  },
  { path: '*', redirect: '/404', hidden: true }
]

export const asyncNoneRouterMap = [
  { path: '/dashboard', component: () => import('@/views/pilih/order'), hidden: true },
  { path: '*', redirect: '/404', hidden: true }
]

export const asyncBasicRouterMap = [
  { path: '/dashboard', component: () => import('@/views/pilih/order'), hidden: true },
  { path: '/topup', component: () => import('@/views/topup/index'), hidden: true },
  // { path: '/locker/:id', component: () => import('@/views/pilih/locker'), hidden: true },
  { path: '/pay/:productId', component: () => import('@/views/pilih/pay'), hidden: true },
  { path: '/token/:occupationId', component: () => import('@/views/pilih/token'), hidden: true },
  { path: '/payment-success', component: () => import('@/views/payment/index'), hidden: true },
  { path: '/payment-failed', component: () => import('@/views/payment/failed'), hidden: true },
  { path: '/billing', component: () => import('@/views/billing/index'), hidden: true },
  { path: '*', redirect: '/404', hidden: true }
]



// WEBPACK FOOTER //
// ./src/router/index.js